export default function trim_object_spaces(obj) {
    if (typeof obj !== 'object' || obj === null) {
        // Base case: if the current value is not an object, return the trimmed value
        if (typeof obj === 'string') {
            return obj.trim();
        }
        return obj;
    }

    // Otherwise, iterate over the object keys and recursively trim values
    for (let key in obj) {
        if (key in obj) {
            obj[key] = trim_object_spaces(obj[key]);
        }
    }

    return obj;
}